var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 .5a.5.5 0 0 0-1 0v1a2 2 0 0 0-2 2V10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2v-1a.5.5 0 0 0-1 0v1H3zM9 3v-.5H3V3a.5.5 0 0 1-1 0v-.5a1 1 0 0 0-1 1V5h10V3.5a1 1 0 0 0-1-1V3a.5.5 0 0 1-1 0M1 6h10v4a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm1.5 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  })));
});
const SvgCalendarsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDAuNUMzIDAuMjIzODU4IDIuNzc2MTQgMCAyLjUgMEMyLjIyMzg2IDAgMiAwLjIyMzg1OCAyIDAuNUwyIDEuNUMwLjg5NTQzMSAxLjUgMCAyLjM5NTQzIDAgMy41VjVWNlYxMEMwIDExLjEwNDYgMC44OTU0MzEgMTIgMiAxMkgxMEMxMS4xMDQ2IDEyIDEyIDExLjEwNDYgMTIgMTBWNlY1VjMuNUMxMiAyLjM5NTQzIDExLjEwNDYgMS41IDEwIDEuNVYwLjUwMDA2OUMxMCAwLjIyMzkyNiA5Ljc3NjE0IDYuODU0NTNlLTA1IDkuNSA2Ljg1NDUzZS0wNUM5LjIyMzg2IDYuODU0NTNlLTA1IDkgMC4yMjM5MjYgOSAwLjUwMDA2OVYxLjVIM1YwLjVaTTkgMy4wMDAwN1YyLjVIM1YzQzMgMy4yNzYxNCAyLjc3NjE0IDMuNSAyLjUgMy41QzIuMjIzODYgMy41IDIgMy4yNzYxNCAyIDNMMiAyLjVDMS40NDc3MiAyLjUgMSAyLjk0NzcyIDEgMy41VjVIMTFWMy41QzExIDIuOTQ3NzIgMTAuNTUyMyAyLjUgMTAgMi41VjMuMDAwMDdDMTAgMy4yNzYyMSA5Ljc3NjE0IDMuNTAwMDcgOS41IDMuNTAwMDdDOS4yMjM4NiAzLjUwMDA3IDkgMy4yNzYyMSA5IDMuMDAwMDdaTTEgNkgxMVYxMEMxMSAxMC41NTIzIDEwLjU1MjMgMTEgMTAgMTFIMkMxLjQ0NzcyIDExIDEgMTAuNTUyMyAxIDEwVjZaTTIuNSA3QzIuMjIzODYgNyAyIDcuMjIzODYgMiA3LjVDMiA3Ljc3NjE0IDIuMjIzODYgOCAyLjUgOEg1LjVDNS43NzYxNCA4IDYgNy43NzYxNCA2IDcuNUM2IDcuMjIzODYgNS43NzYxNCA3IDUuNSA3SDIuNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";